import React from "react";
import { Card, CardBody } from "reactstrap";
import { SettingsPremiumBadge } from "./SettingsPremiumBadge";

export const Section = ({ title, children, premium_section }) => {

    return (
        <Card className={`mb-4 premium-rounded-corners p-3 card_shadow ${title ? "" : "start_game_bg"}`}>
            <CardBody>
                {(title || premium_section) && (
                    <div className="d-flex align-items-center mb-2">
                    {title && <h3 className="fw_700 mb-0">{title}</h3>}
                    {premium_section && <SettingsPremiumBadge />}
                    </div>
                )}
                {children}
            </CardBody>
        </Card>
    )
};


// WEBPACK FOOTER //
// ./src/c/Section.js